(function () {
    'use strict';

    angular
        .module('app.service')
        .factory('loginService', loginService);

    function loginService($http, apiUrl, enumService, $rootScope, sysCode,
        commonService) {
        var service = {
            login: login,
            loginByPerSerilNo: loginByPerSerilNo,
            logout: logout,
            tokenTransfer: tokenTransfer,
            tokenTransferByAccount: tokenTransferByAccount,
            modifyUserPassword: modifyUserPassword,
            forgetPWD: forgetPWD,
            directModifyUserPassword: directModifyUserPassword,
            registerOutsideUser: registerOutsideUser,
            checkToken: checkToken,
            getSsoInfo: getSsoInfo,
            setSsoParams: setSsoParams,
            get: get,
            editUserProfile: editUserProfile,
            sendVerifyCodeFromPhone: sendVerifyCodeFromPhone,
            verifyCodeCheckFromPhone: verifyCodeCheckFromPhone,
            validateTel: validateTel,
            getPwdConstrain: getPwdConstrain,
            checkVerifyCode: checkVerifyCode,
            produceVerifyCodeFromSignUp: produceVerifyCodeFromSignUp,
            verifyCodeCheckFromSignUp: verifyCodeCheckFromSignUp,
            // QueryCaptcha: QueryCaptcha,
            // chkCaptcha: chkCaptcha,

        };

        function replaceFunc(data) {
            if (editPwdErrorLogic(data.data.Result, data.data.ResultValue)) {
                return data.data;
            }
        }

        function basicFunc(data) {
            if (handleSsoLogic(data.data.Result)) {
                return data.data;
            }
        }

        function multipleSerNoFunc(data) {
            if (data.data.length === 1 && handleSsoLogic(data.data[0].Result, data.data[0].ResultValue)) {
                return data.data[0];
            } else if (data.data.length > 1) {
                return data.data;
            }
        }

        function setSsoParams(param) {
            param.sysCode = sysCode;
            if (sessionStorage.getItem('token')) {
                param.token = sessionStorage.getItem('token');
            }
        }

        function get() {
            var param = {
                langSerilNo : 1
            };
            
            return $http.post(apiUrl.tsApi + 'login', param);
        }

        function handleSsoLogic(ssoCode, resultNumber) {
            if (!resultNumber) {
                resultNumber = 1;
            }

            switch (ssoCode) {
                case enumService.sso.success:
                    return true;
                case enumService.sso.error:
                    toastr.error($rootScope.translate.commonErrorMessage);
                    return false;
                case enumService.sso.mustModifydwP://2023-07-10 Johnson 資安2023
                    toastr.info($rootScope.translate.ssoMustModifyPwd);
                    return true;
                case enumService.sso.commonErrorMessage:
                    toastr.error($rootScope.translate.commonErrorMessage);
                    return false;
                case enumService.sso.notExist:
                    //toastr.error($rootScope.translate.ssoAccountNotExist);
                    toastr.error($rootScope.translate.ssoErrorInCommonUse);
                    return false;
                case enumService.sso.disable:
                    //toastr.error($rootScope.translate.commonDisable);
                    toastr.error($rootScope.translate.ssoErrorInCommonUse);
                    return false;
                case enumService.sso.isLock:
                    toastr.error($rootScope.translate.commonIsLock);
                    return false;
                case enumService.sso.tokenNotExist:
                    toastr.error($rootScope.translate.commonNotExistToken);
                    return false;
                case enumService.sso.dwpError://2023-07-10 Johnson 資安2023
                    //toastr.error($rootScope.translate.commonNotExist);
                    toastr.error($rootScope.translate.ssoErrorInCommonUse);
                    return false;
                case enumService.sso.notFindAccount:
                    toastr.error($rootScope.translate.ssoNotFindAccount);
                    return false;
                case enumService.sso.accountIsNotActive:
                    //toastr.error($rootScope.translate.ssoAccountIsNotActive);
                    toastr.error($rootScope.translate.ssoErrorInCommonUse);
                    return false;
                case enumService.sso.illegalRegister:
                    toastr.error($rootScope.translate.illegalRegister);
                    return false;
                case enumService.sso.dwpErrorIsLock://2023-07-10 Johnson 資安2023
                    //toastr.error($rootScope.translate.ssoPwdErrorIsLock);
                    toastr.error($rootScope.translate.ssoErrorInCommonUse);
                    return false;
                case enumService.sso.lockUnReslove:
                    var commonUnLock = _.replace($rootScope.translate.commonUnLock, '?', resultNumber);
                    toastr.error(commonUnLock);
                    return false;
                case enumService.sso.waitForLock:
                    toastr.error($rootScope.translate.waitForLock);
                    return false;
                case enumService.sso.isTaiEmail:
                    toastr.warning($rootScope.translate.ssoIsTaiEmail);
                    return false;
                case enumService.sso.reCaptchaFail:
                    toastr.warning($rootScope.translate.commonReCaptchaFail);
                    return false;
            }
        }

        function editPwdErrorLogic(ssoCode, resultNumber) {
            var ssoPwdMustBigThan = _.replace($rootScope.translate.ssoPwdMustBigThan, '?', resultNumber);
            var ssoPwdNotSameRecent = _.replace($rootScope.translate.ssoPwdNotSameRecent, '?', resultNumber);
            var ssoPwdModifyWeek = _.replace($rootScope.translate.ssoPwdModifyWeek, '?', resultNumber);

            switch (ssoCode) {
                case enumService.sso.userAlreadyValidate:
                    toastr.info($rootScope.translate.userAlreadyValidate);
                    return false;
                case enumService.sso.dwpError://2023-07-10 Johnson 資安2023
                    toastr.error($rootScope.translate.commonPwdError);
                    return false;
                case enumService.sso.dwpJustEnAndNumber://2023-07-10 Johnson 資安2023
                    toastr.error($rootScope.translate.ssoPwdJustEnAndNumber);
                    return false;
                case enumService.sso.dwpMustBigThan://2023-07-10 Johnson 資安2023
                    toastr.error(ssoPwdMustBigThan);
                    return false;
                case enumService.sso.dwpNeedContainEnAndNumber://2023-07-10 Johnson 資安2023
                    toastr.error($rootScope.translate.ssoPwdNeedContainEnAndNumber);
                    return false;
                case enumService.sso.notExist:
                    toastr.error($rootScope.translate.ssoAccountNotExist);
                    return false;
                case enumService.sso.dwpNotContainueThree://2023-07-10 Johnson 資安2023
                    toastr.error($rootScope.translate.ssoPwdNotContainueThree);
                    return false;
                case enumService.sso.dwpNotContainueThreeOrderAndDesc://2023-07-10 Johnson 資安2023
                    toastr.error($rootScope.translate.ssoPwdNotContainueThreeOrderAndDesc);
                    return false;
                case enumService.sso.dwpNotSameAccount://2023-07-10 Johnson 資安2023
                    toastr.error($rootScope.translate.ssoPwdNotSameAccount);
                    return false;
                case enumService.sso.dwpNotSameRecent://2023-07-10 Johnson 資安2023
                    toastr.error(ssoPwdNotSameRecent);
                    return false;
                case enumService.sso.accountNotExist:
                    toastr.error($rootScope.translate.ssoAccountNotExist);
                    return false;
                case enumService.sso.verifyCodeExpired:
                    toastr.error($rootScope.translate.ssoVerifyCodeExpired);
                    return false;
                case enumService.sso.verifyCodeNotExist:
                    toastr.error($rootScope.translate.ssoVerifyCodeNotExist);
                    return false;
                case enumService.sso.emailAlreadyRegister:
                    toastr.error($rootScope.translate.emailAlreadyRegister);
                    return false;
                case enumService.sso.dwpModifyWeek://2023-07-10 Johnson 資安2023
                    toastr.error(ssoPwdModifyWeek);
                    return false;
                case enumService.sso.verifyCodeInValid:
                    toastr.error($rootScope.translate.ssoVerifyCodeInValid);
                    return false;
                case enumService.sso.verifyCodeNotPass:
                    toastr.error($rootScope.translate.verifyCodeNotPass);
                    return false;
                case enumService.sso.newdwPNotSameOlddwP://2023-07-10 Johnson 資安2023
                    //2023-07-10 Johnson 資安2023
                    toastr.error($rootScope.translate.newdwPNotSameOlddwP);
                    return false;
                case enumService.sso.notHavePhone:

                    toastr.error($rootScope.translate.ssoNotHavePhone);
                    return false;
                case enumService.sso.notHaveEmail:
                    toastr.error($rootScope.translate.ssoNotHaveEmail);
                    return false;
                default:
                    return handleSsoLogic(ssoCode);
            }
        }

        function login(params) {
            setSsoParams(params);
            //test error situation
            //recaptcha.response = recaptcha.response + 'ee';
            //console.log('params:', params);

            return $http.post(apiUrl.ssoApi + 'sso/login', params).then(function (data) {
                //console.log('response:', data);
                if (data) {
                    return multipleSerNoFunc(data);
                }
            });
        }

        function loginByPerSerilNo(params) {
            setSsoParams(params);
            return $http.post(apiUrl.ssoApi + 'sso/loginByPerSerilNo', params).then(function (data) {
                return basicFunc(data);
            });
        }

        function logout() {
            var params = {
                'sysCode': sysCode,
                'token': sessionStorage.getItem('token')
            };
            return $http.post(apiUrl.ssoApi + 'sso/logout', params).then(function (data) {
                return basicFunc(data);
            });
        }

        function tokenTransfer(params) {
            return $http.post(apiUrl.ssoApi + 'sso/tokenTransfer', params).then(function (data) {
                return multipleSerNoFunc(data);
            });
        }

        function tokenTransferByAccount(params) {
            return $http.post(apiUrl.ssoApi + 'sso/tokenTransferByAccount', params).then(function (data) {
                return multipleSerNoFunc(data);
            });
        }

        function modifyUserPassword(params) {
            return getSsoInfo().then(function (data) {
                return data.data.userAccount;
            }).then(function (account) {
                params.userAccount = account;
                return $http.post(apiUrl.ssoApi + 'Password/ModifyUserPassword', params).then(function (data) {
                    return replaceFunc(data);
                });
            });
        }

        function forgetPWD(params, recaptcha) {
            //test error situation
            //recaptcha.response = recaptcha.response + 'ee';
            return $http.post(apiUrl.ssoApi + 'Password/ForgetPWD', params).then(function (data) {
                //console.log('resData:', data.data);
                if (data.data) {
                    if (editPwdErrorLogic(data.data.Result, 0)) {
                        return data.data;
                    }
                }
            });
        }

        function directModifyUserPassword(params) {
            return $http.post(apiUrl.ssoApi + 'Password/directModifyUserPassword', params).then(function (data) {
                return replaceFunc(data);
            });
        }

        function checkToken() {
            var param = {};
            setSsoParams(param);
            return $http.post(apiUrl.ssoApi + 'sso/checkToken', param);
        }

        function registerOutsideUser(params) {
            //alert('apiUrl.ssoApi:'+apiUrl.ssoApi);
            return $http.post(apiUrl.ssoApi + 'user/registerOutsideUser', params).then(function (data) {
                    if (editPwdErrorLogic(data.data.Result, data.data.ResultValue)) {
                        return data.data;
                    }
            });
        }

        function getSsoInfo() {
            var param = {
                perSerilNo: sessionStorage.getItem('perSerilNo'),
                sysCode: sysCode,
                token: sessionStorage.getItem('token')
            };
            return $http.post(apiUrl.tsApi + 'employee/ssoInfo', param);
        }

        function editUserProfile(param) {
            setSsoParams(param);
            param.perSerilNo = sessionStorage.getItem('perSerilNo');
            $http.post(apiUrl.tsApi + 'employee/editProfile', param).then(function () {
                sessionStorage.setItem('cName', param.cName);
                $rootScope.$emit('emitCName', param.cName);
                toastr.success($rootScope.translate.commonSaveSuccess);
            });
        }

        function sendVerifyCodeFromPhone(account, recaptcha) {
            var param = {
                userAccount: account
            };
            commonService.setParams(param);
            return $http.post(apiUrl.ssoApi + 'sso/produceVerifyCodeFromPhone', param).then(function (data) {
                return handleSsoLogic(data);
            });
        }

        function verifyCodeCheckFromPhone(param) {
            commonService.setParams(param);
            return $http.post(apiUrl.ssoApi + 'sso/VerifyCodeCheckFromPhone', param).then(function (data) {
                return replaceFunc(data);
            });
        }

        function validateTel(param) {
            return $http.post(apiUrl.ssoApi + 'user/ValidateTel', param);
        }

        function getPwdConstrain() {
            var params = {
                langSerilNo: sessionStorage.getItem('langCode'),
                sysCode: sysCode,
                token: sessionStorage.getItem('token')
            };
            return $http.post(apiUrl.ssoApi + 'password/getPwdConstrainForLanguage', params);
        }

        function checkVerifyCode(params) {
            return $http.post(apiUrl.ssoApi + 'user/CheckVerifyCode', params);
        }

        function produceVerifyCodeFromSignUp(param) {
            return $http.post(apiUrl.ssoApi + 'user/produceVerifyCodeFromSignUp', param).then(function (data) {
                return handleSsoLogic(data);
            });
        }

        function verifyCodeCheckFromSignUp(param) {
            return $http.post(apiUrl.ssoApi + 'user/verifyCodeCheckFromSignUp', param).then(function (data) {
                return handleSsoLogic(data);
            });
        }

        // function QueryCaptcha() {
        //     return $http.post(apiUrl.ssoApi + 'sso/QueryCaptcha').then(function (data) {
        //         return handleSsoLogic(data);
        //     });
        // }
        // function chkCaptcha() {
        //     return $http.post(apiUrl.ssoApi + 'sso/chkCaptcha').then(function (data) {
        //         return handleSsoLogic(data);
        //     });
        // }
        return service;
    }
})();